import { Outlet, useLocation } from "react-router-dom";
import { BottomNav } from "@/components/BottomNav";

export default function Layout() {
  const loc = useLocation();
  const hideNav = ["/login", "/register"].includes(loc.pathname);

  return (
    <div className="min-h-screen bg-bg text-white font-body" data-testid="app-shell">
      <div className="mx-auto w-full max-w-md sm:border-x sm:border-white/5 min-h-screen pb-24 relative">
        <Outlet />
      </div>
      {!hideNav && <BottomNav />}
    </div>
  );
}
